import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu"
import { DropdownMenuItem } from "@/components/ui/dropdown-menu"

type DropdownMenuSelectionProps = React.ComponentPropsWithRef<typeof DropdownMenuPrimitive.Item> & { inset?: boolean }
export const DropdownMenuSelection = ({ ...props }: DropdownMenuSelectionProps) => {
  return (
    <DropdownMenuItem className="focus:bg-surface-hovered gap-2 rounded-md px-2" {...props}>
      {props.children}
    </DropdownMenuItem>
  )
}
